export default __webpack_public_path__ + "static/techgurusk-cae50efa1603b5b2f0416ef5fe56ec34.jpg";